import { makeStyles } from '@mui/styles';
import { Colors } from 'utils';

export const breadcrumbsStyle = makeStyles((theme) => ({
    parent: {
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: 'normal',
        color: '#667085',
        textDecoration: 'none',

        '&:hover': {
            textDecoration: 'underline',
        },
    },
    child: {
        fontSize: '14px',
        fontWeight: '600',
        lineHeight: 'normal',
        color: '#172B4D',
    },
}));
